import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { helper } from 'src/environments/helper';
import { Observable, Subscription, catchError, distinctUntilChanged, finalize, map, of, switchMap, tap } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DocumentePubliceService } from '../documente-publice.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { DocumentePublice } from '../documente-publice.interface';
import { CompartimenteService } from '../../../settings-sidenav/compartimente/compartimente.service';
import { Generic } from 'src/app/interfaces/generic.interface';
import { UsersService } from '../../../settings-sidenav/users-settings/users.service';
import { notDefaultValidator } from 'src/app/shared/validators/not-default';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { MatRadioChange } from '@angular/material/radio';
import { OperatorAddPayload } from '../../operatori-institutii/operatori-institutii.interface';
import { OperatoriInstitutiiService } from '../../operatori-institutii/operatori-institutii.service';

@Component({
    selector: 'app-add-documente-publice',
    templateUrl: './add-documente-publice.component.html',
    styleUrls: ['./add-documente-publice.component.scss']
})
export class AddDocumentePubliceComponent implements OnInit, OnDestroy {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    // general success alert
    successTitle: string = environment.config.customNotifications.headers.successForm;
    successIcon: string = environment.config.customNotifications.icons.success;
    successType: string = environment.config.customNotifications.icons.success;
    helper = helper;

    isAddMode = false;

    token!: string;
    isLoading = false;

    form: FormGroup = new FormGroup({
        id_directie: new FormControl('-1', [Validators.required, notDefaultValidator('-1')]),
        id_compartiment: new FormControl('-1'),
        id_document_year: new FormControl('-1', [Validators.required, notDefaultValidator('-1')]),
        id_document_type: new FormControl('-1', [Validators.required, notDefaultValidator('-1')]),
        id_operator: new FormControl(''),
        name: new FormControl(''),
        archive_to: new FormControl('', [Validators.required]),
        archive_date: new FormControl(''),
        active: new FormControl(''),
        active_from: new FormControl(''),
        ora_from: new FormControl(''),
        active_end: new FormControl(''),
        ora_end: new FormControl(''),
        files: new FormControl([]),
        observations: new FormControl(''),
    });

    formOperator: FormGroup = new FormGroup({
        name: new FormControl(''),
        type: new FormControl('-1'),
        id_directie: new FormControl('-1'),
        id_compartiment: new FormControl('-1'),
    });


    uploading: any = {
        documente_fotografii: false
    }

    files: any = {
        documente_fotografii: []
    }

    directiiActive!: Generic[];
    compartimenteActive$!: Observable<Generic[]>;
    usersActive$: Generic[] = [];
    aniList!: Generic[];
    tipuriDocumente!: Generic[];
    userTypes!: Generic[];

    filteredActiveUsers!: any[];
    activeUsersChangesSubscription = new Subscription();

    compartimenteActiveOperator$!: Observable<Generic[]>;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<AddDocumentePubliceComponent>,
        private documentePubliceService: DocumentePubliceService,
        private notificationService: NotificationService,
        private authService: AuthService,
        private compartimenteService: CompartimenteService,
        private usersService: UsersService,
        public toastr: ToastrService,
        private operatoriInstitutiiService: OperatoriInstitutiiService
    ) {
        this.processToken();
        this.directiiActive = this.data.directiiActive;
        this.aniList = this.data.aniList;
        this.tipuriDocumente = this.data.tipuriDocumente;
        this.userTypes = this.data.userTypes;
    }

    ngOnInit(): void {
        this.renderActiveUsersSearch();
    }

    ngOnDestroy(): void {
        if (this.activeUsersChangesSubscription) {
            this.activeUsersChangesSubscription.unsubscribe();
        }
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.documentePubliceService.setToken(token);
        });
    }

    submitForm() {
        // this.isLoading = true;

        const {
            id_directie,
            id_compartiment,
            id_document_year,
            id_document_type,
            id_operator,
            archive_to,
            archive_date,
            active_from,
            active_end,
            ora_from,
            ora_end,
            files,
            observations
        } = this.form.value as any;

        const newDocument: DocumentePublice = {
            id_directie,
            id_compartiment,
            id_document_year,
            id_document_type,
            id_operator,
            archive_to,
            archive_date: archive_date ? this.formatDate(archive_date) : '',
            active_from: active_from && ora_from ? this.combineDateAndTime(active_from, ora_from) : '',
            active_end: active_end && ora_end ? this.combineDateAndTime(active_end, ora_end) : '',
            files,
            observations,
        };

        console.log(newDocument);


        // this.documentePubliceService
        //     .storeDocument(newDocument)
        //     .pipe(finalize(() => (this.isLoading = false)))
        //     .subscribe({
        //         next: (res) => {
        //             this.dialogRef.close({ success: true });
        //         },
        //         error: (err) => {
        //             let msg;
        //             try {
        //                 // try to catch the message from server
        //                 msg = err.error.errors.message[0];
        //             } catch (error) {
        //                 // controll output message
        //                 msg = helper.dialogConfig.generalMessages.error;
        //             }
        //             this.notificationService.warningSwal(
        //                 this.errorTitle,
        //                 msg,
        //                 this.errorIcon
        //             );
        //         },
        //     });
    }

    onDirectieChange(directieId: number): void {
        this.form.controls['id_compartiment'].patchValue('-1');
        this.form.controls['id_operator'].patchValue('-1');

        if (directieId == -1) {
            this.compartimenteActive$ = of([]);
            return;
        }

        if (directieId) {
            this.loadCompartimenteActive(directieId);
            this.loadUsersActive();
        } else {
            this.compartimenteActive$ = new Observable<Generic[]>((observer) => {
                observer.complete();
            });
        }
    }

    loadCompartimenteActive(directieId?: number) {
        this.isLoading = true;
        let compartimenteObservable$ = directieId
            ? this.compartimenteService.getCompartimenteByDirectieId(directieId)
            : this.compartimenteService.getCompartimenteActive();

        this.compartimenteActive$ = compartimenteObservable$.pipe(
            map((results: any) => [...results]),
            finalize(() => {
                this.isLoading = false;
            })
        );
    }

    onDirectieCompartimentChange(compartimentId: number): void {
        this.loadUsersActive();
    }

    loadUsersActive() {
        let data = {
            directie_id: this.form.get('id_directie')?.value,
            compartiment_id: this.form.get('id_compartiment')?.value === '-1' ? '' : this.form.get('id_compartiment')?.value,
        }

        this.isLoading = true;
        this.usersService
            .getActiveUsersByOrganigrama(data)
            .pipe(
                map((results: any) => [...results]),
                finalize(() => (this.isLoading = false))
            ).subscribe({
                next: (res) => {
                    this.usersActive$ = res;
                    this.filteredActiveUsers = res;
                }
            });
    }

    renderActiveUsersSearch() {
        this.activeUsersChangesSubscription = this.form.controls['name'].valueChanges.pipe(
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredActiveUsers = this.usersActive$;
                    return of(this.usersActive$);
                }
                return this.filterActiveUsers(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredActiveUsers = data;
            }),
            catchError(() => of([]))
        ).subscribe();
    }

    filterActiveUsers(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.usersActive$.filter(user =>
            this.normalizeString(user.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    normalizeString(value: string): string {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    }

    onActiveUsersChange(user: { id: number, name: string }) {
        if (this.activeUsersChangesSubscription) {
            this.activeUsersChangesSubscription.unsubscribe();
        }

        this.form.controls['id_operator'].setValue(user.id);

        this.renderActiveUsersSearch();
    }

    onAddMode() {
        this.isAddMode = !this.isAddMode;

        const name = this.formOperator.get('name') as FormControl;
        const type = this.formOperator.get('type') as FormControl;
        const id_directie = this.formOperator.get('id_directie') as FormControl;
        const id_compartiment = this.formOperator.get('id_compartiment') as FormControl;

        if (this.isAddMode) {
            name.setValidators([Validators.required]);
            type.setValidators([Validators.required, notDefaultValidator('-1')]);
            id_directie.setValidators([Validators.required, notDefaultValidator('-1')]);

            this.formOperator.get('id_directie')?.patchValue(this.form.get('id_directie')?.value);
            this.formOperator.get('id_compartiment')?.patchValue(this.form.get('id_compartiment')?.value);
            this.formOperator.get('name')?.patchValue(this.form.get('user')?.value);

            this.onDirectieOperatorChange(this.form.get('id_directie')?.value);
        } else {
            name.patchValue('');
            name.clearValidators();
            name.setErrors(null);

            type.patchValue('-1');
            type.clearValidators();
            type.setErrors(null);

            id_directie.patchValue('-1');
            id_directie.clearValidators();
            id_directie.setErrors(null);

            id_compartiment.patchValue('-1');
        }

        this.formOperator.updateValueAndValidity();
    }

    onArhivareChange(event: MatRadioChange) {
        const archiveDate = this.form.get('archive_date') as FormControl;

        if (event.value === true) {
            archiveDate.setValidators([Validators.required]);
        } else {
            archiveDate.patchValue('');
            archiveDate.clearValidators();
            archiveDate.setErrors(null);
        }

        this.form.updateValueAndValidity();
    }

    addFile(event: any, key: 'documente_fotografii') {
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files) {
            return;
        }

        const files = inputElement.files;

        // Iterate through the selected files and append them to the 'files' array in the form
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            this.uploading[key] = true;

            const formData = new FormData();
            formData.append('file', file, file.name);

            this.documentePubliceService.fileUpload(formData)
                .subscribe({
                    next: (result: any) => {
                        let response = (typeof result.status_code !== 'undefined' ? result : result.error);
                        if (typeof response.status_code !== 'undefined') {
                            if (response.status_code == 200 && typeof response.data !== 'undefined') {
                                // Handle the uploaded file by adding it to the 'files' array in the form
                                const currentFiles = this.form.get('files')?.value || [];
                                currentFiles.push(result.data);
                                this.form.get('files')?.setValue(currentFiles);

                                this.uploading[key] = false;

                                this.openToast({
                                    title: this.successTitle,
                                    message: 'Fișierul dvs. a fost adăugat cu succes.',
                                    type: this.successIcon
                                });
                            }
                        } else {
                            // Handle error cases here
                            let errorMessage = environment.config.customNotifications.generalMessages.fileErrorMsg;
                            this.notificationService.warningSwal(this.errorTitle, errorMessage, this.errorIcon);
                            this.isLoading = false;
                            this.uploading[key] = false;
                        }
                    },
                    error: (result: any) => {
                        this.isLoading = false;
                        this.uploading[key] = false;
                        this.onHttpError(result.error);
                    }
                });
        }
    }

    removeFile(index: number) {
        const currentFiles = this.form.get('files')?.value || [];
        currentFiles.splice(index, 1);
        this.form.get('files')?.setValue(currentFiles);
    }

    openToast(object: any) {
        const { type, message, title } = object;

        let options = this.toastr.toastrConfig;
        options.progressBar = true;
        options.preventDuplicates = true;
        options.closeButton = true;

        const inserted = this.toastr.show(message, title, options, options.iconClasses[type]
        );
    }

    onHttpError(res: any, showErrorsInToast: boolean = false) {
        if (res.errors && res.errors.message && res.errors.message.length > 0) {
            res.errors.message.forEach((msg: string) => {
                if (showErrorsInToast) {
                    this.openToast({ title: this.errorTitle, message: msg, type: this.errorType });
                }
                else {
                    this.notificationService.warningSwal(this.errorTitle, msg, this.errorIcon);
                }
            });
        }
        else {
            let errorMessage = environment.config.customNotifications.generalMessages.error;
            this.notificationService.warningSwal(this.errorTitle, errorMessage, this.errorIcon);
        }
    }

    formatDate(date: Date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    combineDateAndTime(date: Date, time: string): string {
        const [hours, minutes] = time.split(':');

        const datePart = this.formatDate(date);

        const h = hours.padStart(2, '0');
        const m = minutes.padStart(2, '0');

        return `${datePart} ${h}:${m}`;
    }

    onDirectieOperatorChange(directieId: number): void {
        this.formOperator.controls['id_compartiment'].patchValue('-1');
        if (directieId == -1) {
            this.compartimenteActiveOperator$ = of([]);
            return;
        }

        if (directieId) {
            this.loadCompartimenteActiveOperator(directieId);
        } else {
            this.compartimenteActiveOperator$ = new Observable<Generic[]>((observer) => {
                observer.complete();
            });
        }
    }

    loadCompartimenteActiveOperator(directieId?: number) {
        this.isLoading = true;
        let compartimenteObservable$ = directieId
            ? this.compartimenteService.getCompartimenteByDirectieId(directieId)
            : this.compartimenteService.getCompartimenteActive();

        this.compartimenteActiveOperator$ = compartimenteObservable$.pipe(
            map((results: any) => [...results]),
            finalize(() => {
                this.isLoading = false;
            })
        );
    }

    submitFormOperator() {
        this.isLoading = true;

        const { name, type, id_directie, id_compartiment } = this.form
            .value as any;

        const newOperator: any = {
            name,
            type,
            id_directie,
            id_compartiment,
        };

        this.operatoriInstitutiiService
            .storeOperator(newOperator)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.onAddMode();
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
